import {
  createStyles, FileInput, Button as MantineButton, Select,
} from '@mantine/core';
import { useState } from 'react';
import { useStyles } from 'src/features/fnoActivationForm/incomeProofForm.styles';
import { CustomModal } from '../../../components/customModal';
import { Button, TextInput } from '../../../components/atoms';
import upload from "../../../assets/icons/upload.svg";

const useModalStyles = createStyles((theme) => ({
  previewImageWrapper: {
    height: 300,
    margin: "auto",
    paddingBottom: 16,
    paddingTop: 20,
    [`@media (max-width: ${theme.breakpoints.xs})`]: {
      width: "100%",
    },
  },
  image: {
    height: "100%",
    width: "100%",
    objectFit: "contain",
  },
  modalWrapper: {
    width: "100%",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    paddingBottom: 0,
  },
}));
interface IIncomeProofModal {
  opened: boolean;
  onClose: () => void;
  file: File | null;
  setFile: (file: File | null) => void;
  handleDiscard: () => void
  handleSave: (docTypeVal:string, docPasswordVal:string) => void
}
interface DocOptions {
  value: string;
  label: string;
}

const docOpts: Array<DocOptions> = [
  { value: 'bank statement', label: 'Bank statement' },
  { value: 'form 16', label: 'Form 16' },
  { value: 'dp holding', label: 'DP Holding' },
  { value: 'it return', label: 'IT Return' },
  { value: 'salary slip', label: 'Salary slip' },
  { value: 'net worth certificate', label: 'Net worth certificate' },
];

const IncomeProofModal = ({
  opened,
  onClose,
  file,
  setFile,
  handleDiscard,
  handleSave,
}: IIncomeProofModal) => {
  const { classes: modalClasses } = useModalStyles();
  const { classes, cx } = useStyles();
  const [isPassRequired, setIsPassRequired] = useState(false);
  const [docPassword, setDocPassword] = useState('');
  const [docType, setDocType] = useState<string | null>(null);
  const [errors, setErrors] = useState({
    fileError: '',
    selectError: '',
  });
  const getLabel = (value: string) => {
    const selected = docOpts.find((doc) => doc.value === value);
    return selected ? selected.label : '';
  }

  const handleChangePasswordRequired = () => {
    setIsPassRequired((prev) => !prev);
    setDocPassword('');
  };

  const handlePasswordInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isPassRequired) {
      setDocPassword(e.target.value);
    } else {
      setDocPassword('');
    }
  };

  const onDocTypeChange = (val: string | null) => {
    setDocType(val);
    setErrors({
      fileError: '',
      selectError: '',
    });
  };

  const handleClickSave = () => {
    if (docType) {
      if (isPassRequired && docPassword) {
        handleSave(docType, docPassword)
      } else if (!isPassRequired) {
        handleSave(docType, "")
      }
    }
  }

  const handleCloseModal = () => {
    setDocPassword('');
    setDocType(null);
    setIsPassRequired(false);
    setErrors({
      fileError: '',
      selectError: '',
    });
    handleDiscard();
  }

  return (
    <CustomModal
      opened={opened}
      onClose={onClose}
      className={modalClasses.modalWrapper}
      closeOnClickOutside={false}
    >
      <p className="content_md_semibold">Income proof details</p>
      <div className={modalClasses.previewImageWrapper}>
        <div className={classes.formWrapper}>
          <Select
            value={docType}
            onChange={onDocTypeChange}
            data={docOpts}
            placeholder="Select Document"
            error={errors.selectError}
          />
          {docType ? (
            <FileInput
            // @ts-ignore
              placeholder={`Upload ${getLabel(docType)}`}
              value={file}
              onChange={setFile}
              accept="image/jpg,image/jpeg,image/png,.doc,.docx,.txt,.pdf"
              error={errors.fileError}
              classNames={{
                wrapper: classes.fileInputWrapper,
                placeholder: classes.fileInputPlaceholder,
              }}
              icon={<img src={upload} alt="upload" />}
            />
          ) : null}
          {docType ? (
            <label htmlFor="scales" className={classes.checkLabel}>
              <input
                type="checkbox"
                checked={isPassRequired}
                onChange={handleChangePasswordRequired}
                className={classes.checkbox}
              />
              <p className={cx(classes.inputDescription, classes.terms)}>
                Check if the Document is password protected
              </p>
            </label>
          ) : null}
          {isPassRequired ? (
            <TextInput
              type="password"
              name="password"
              placeholder="Enter the Document password here"
              autoComplete="off"
              required
              onChange={handlePasswordInput}
              value={docPassword}
            />
          ) : null}
        </div>
      </div>
      <div className={modalClasses.footer}>
        <MantineButton
          onClick={handleCloseModal}
          radius={8}
          variant="outline"
          type="button"
        >
          Discard
        </MantineButton>
        <Button
          onClick={handleClickSave}
          radius={8}
          variant="filled"
          type="button"
        >
          Save
        </Button>
      </div>
    </CustomModal>
  );
};

export default IncomeProofModal;
